export const GET_USER = 'get_user'
export const CLEAR_USER = 'clear_user'
export const GET_ORDER_ADDRESS = 'get_orderAddress'
export const EDITING_ADDRESS = 'editing_Address'
export const CHANGE_TOWN = 'chenge_Town'


// WEBPACK FOOTER //
// ./src/store/mutation-types.js